module.exports = ".auto-main-card {\r\n  margin-top: 10px;\r\n}\r\n.mat-card-title {\r\n  font-size: 22px;\r\n  margin-left: -10px;\r\n}\r\n.main-radio-group {\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n}\r\n.main-radio-button {\r\n  margin: 5px;\r\n}\r\n.main-selected-value {\r\n  margin: 15px 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/main.component.css
// module id = ./src/app/main/main.component.css
// module chunks = main